module.exports = __webpack_public_path__ + "img/MunsterSmall2.65b9fdd8.png";